import { formatLeadIntent } from './lead-show-page/utils'

const AUTO_REPLY_CONTACT_METHOD = 'Auto Response'

export const ALL_INTEREST_FILTER = 'all'

export const LEAD_INTEREST_CATEGORIES = [
  {
    label: 'Community',
    intents: ['Connect me with other golfers'],
  },
  {
    label: 'Break Scoring Barriers',
    intents: ['Help me shoot lower scores'],
  },
  {
    label: 'Introduction to Golf',
    intents: [
      'Introduce me to golf',
      'Introduce my child to golf',
      'Introduce my family to golf',
    ],
  },
  {
    label: 'Improve Game',
    intents: [
      'Fix a specific problem in my golf game',
      'Help my junior golfer improve',
    ],
  },
]

const INTENT_TO_CATEGORY = LEAD_INTEREST_CATEGORIES.reduce((acc, category) => {
  category.intents.forEach(intent => {
    acc[intent] = category.label
  })
  return acc
}, {})

/**
 * Contacted tab contract: a lead is contacted only when the coach recorded a
 * contact method via Mark as Contacted (`setCoachingLeadContact`). Auto-replies
 * set `contactMethod` to "Auto Response" and remain on the New tab even when
 * `contactedAt` is set. Legacy rows with only `contactedAt` and a null
 * `contactMethod` also stay on New until the coach picks a method.
 */
export function isLeadContacted(lead) {
  const method = lead?.contactMethod
  return Boolean(method) && method !== AUTO_REPLY_CONTACT_METHOD
}

export function isUnviewedNewLead(lead) {
  return !isLeadContacted(lead) && lead?.viewedAt == null
}

export function partitionLeadsByContactStatus(leads = []) {
  const awaitingResponseLeads = leads.filter(lead => !isLeadContacted(lead))
  const contactedLeads = leads.filter(lead => isLeadContacted(lead))

  return { awaitingResponseLeads, contactedLeads }
}

export function getLeadInterestFilterValue(intent) {
  const cleaned = formatLeadIntent(intent)
  if (!cleaned) return ''
  return INTENT_TO_CATEGORY[cleaned] || cleaned
}

export function leadMatchesInterestFilter(lead, selectedInterest) {
  if (!selectedInterest || selectedInterest === ALL_INTEREST_FILTER) {
    return true
  }
  return getLeadInterestFilterValue(lead?.intent) === selectedInterest
}

export function getLeadInterestFilterOptions(leads = []) {
  const present = new Set()
  leads.forEach(lead => {
    const value = getLeadInterestFilterValue(lead?.intent)
    if (value) present.add(value)
  })

  const categoryLabels = LEAD_INTEREST_CATEGORIES.map(
    category => category.label,
  ).filter(label => present.has(label))
  const remaining = [...present]
    .filter(value => !categoryLabels.includes(value))
    .sort((a, b) => a.localeCompare(b))

  return [
    { value: ALL_INTEREST_FILTER, label: 'All Interests' },
    ...categoryLabels.map(label => ({ value: label, label })),
    ...remaining.map(label => ({ value: label, label })),
  ]
}
